import { useCallback } from "react"

import { useTranslation } from "react-i18next"
import { Button } from "semantic-ui-react"
import uuid from "uuid"

import MultiImageChooser from "components/lib/Choosers/MultiImageChooser"

const MultiImage = ({ field, fieldValue: images = [], ideaId, isEditing, updateIdea }) => {
  const { t } = useTranslation()
  const addImage = useCallback(
    (_f, n, imageSrc) => {
      const updatedImages = [{ value: imageSrc, name: n, _id: uuid.v4() }, ...images]
      updateIdea(updatedImages, ["templated", field.id])
    },
    [images, field, updateIdea],
  )

  const removeImage = useCallback(
    (_id) => {
      const updatedImages = images.filter((i) => i._id !== _id)
      updateIdea(updatedImages, ["templated", field.id])
    },
    [images, field, updateIdea],
  )

  const maxImages = field.maxImages || 10
  const disableUpload = field.maxImages ? images.length >= maxImages : null

  return (
    <MultiImageChooser
      editing={isEditing}
      onComplete={addImage}
      deleteFile={removeImage}
      forType="idea"
      forId={ideaId}
      getFileUrl={(image) => image.value}
      title={t("multiimage.upload.title")}
      description={t("multiimage.upload.info")}
      images={images}
      maxImages={maxImages}
      trigger={<Button primary icon="add" content={t("multiimage.upload.action")} disabled={disableUpload} />}
    />
  )
}

export default MultiImage
